<script>
  /**
 *
 *
 *
 *
 *
 */

  import ImageTile from './ImageTile.svelte';
  import ProductInformation from './ProductInformation.svelte';
  import Rating from './Rating.svelte';

  /*                */

  let { mainVariation, recommendations, featuresState = {}, contentDresonRule } = $props();
  let attributeNames = $state(
    mainVariation && mainVariation.comparisonAttributes
      ? mainVariation.comparisonAttributes.map((attribute) => attribute.label)
      : []
  );

  recommendations
    ?.map((recommendation) => recommendation._embedded['o:variation'])
    .forEach((variation) => {
      const baseDetailViewUrl = variation._links['o:base-detail-view-url']?.href;
      const variationDetailViewUrl = variation._links['o:variation-detail-view-url']?.href;
      const legacyDetailView = variation._links['o:detail-view']?.href;

      let bestDetailViewUrl = legacyDetailView;
      if (featuresState.ENABLE_NEW_PRODUCT_LINK && baseDetailViewUrl && variationDetailViewUrl)
        bestDetailViewUrl = variation.isQueryUrl ? baseDetailViewUrl : variationDetailViewUrl;

      variation._links['o:best-detail-view-url'] = { href: bestDetailViewUrl };
    });
</script>

{#if recommendations && recommendations.length > 0 && attributeNames.length > 0}
  <div class="reco_comparison__table__container">
    <table>
      <thead>
        <tr>
          <th class="column oc-headline-50">
            <oc-tag-v1 size="25" variant="info-secondary">Gewähltes Produkt</oc-tag-v1>
            <div class="reco_comparison__table__header_title">
              {mainVariation.brandName}<br />{mainVariation.name}
            </div></th>
          {#each recommendations as recommendation}
            <th class="column">
              <div class="product-tag-placeholder"></div>
              <div class="reco_comparison__table__header_title">
                <oc-link-v2
                  class="oc-headline-50"
                  base64-href={featuresState.ENABLE_NEW_PRODUCT_LINK &&
                  recommendation._embedded['o:variation'].isQueryUrl
                    ? btoa(
                        recommendation._embedded['o:variation']._links[
                          'o:variation-detail-view-url'
                        ]?.href
                      )
                    : undefined}>
                  <a
                    class="reco_comparison__table__adslink"
                    href={recommendation._embedded['o:variation']._links['o:best-detail-view-url']
                      ?.href}>
                    {recommendation.brandName}<br />{recommendation._embedded['o:variation'].name}
                  </a>
                </oc-link-v2>
              </div></th>
          {/each}
        </tr>
        <tr>
          <td class="column"
            ><div class="reco_comparison__table__header_data">
              <ImageTile image={mainVariation.image} />
              <ProductInformation
                variation={mainVariation}
                pricing={mainVariation.formattedPrice}
                minimumOrderValueEligible={mainVariation.minimumOrderValueEligible}
                {contentDresonRule} />
            </div></td>
          {#each recommendations as recommendation}
            <td class="column"
              ><div class="reco_comparison__table__header_data">
                <oc-link-v2
                  base64-href={featuresState.ENABLE_NEW_PRODUCT_LINK &&
                  recommendation._embedded['o:variation'].isQueryUrl
                    ? btoa(
                        recommendation._embedded['o:variation']._links[
                          'o:variation-detail-view-url'
                        ]?.href
                      )
                    : undefined}>
                  <a
                    href={recommendation._embedded['o:variation']._links['o:best-detail-view-url']
                      ?.href}>
                    <ImageTile image={recommendation.image} />
                  </a>
                </oc-link-v2>
                <ProductInformation
                  variation={recommendation._embedded['o:variation']}
                  pricing={recommendation.formattedPrice}
                  minimumOrderValueEligible={recommendation.minimumOrderValueEligible}
                  {contentDresonRule} />
              </div></td>
          {/each}
        </tr>
      </thead>
      <tbody>
        {#each attributeNames as attributeName}
          <tr>
            <td class="column oc-copy-100">
              <h2 class="attribute-header oc-headline-25">{attributeName}</h2>
              <ul>
                <li>
                  <ul>
                    {#each mainVariation.comparisonAttributes.find((attribute) => attribute.label === attributeName)?.values || [] as value}
                      <li>{value}</li>
                    {/each}
                  </ul>
                </li>
              </ul>
            </td>
            {#each recommendations as recommendation}
              <td class="column oc-copy-100">
                <div class="attribute-header-placeholder"></div>
                <ul>
                  {#each recommendation._embedded['o:variation'].comparisonAttributes.find((attribute) => attribute.label === attributeName)?.values || [] as value}
                    <li>{value}</li>
                  {/each}
                </ul></td>
            {/each}
          </tr>
        {/each}
        <tr>
          <td class="column oc-copy-100">
            <h2 class="attribute-header oc-headline-25">Bewertungen</h2>
            <Rating variation={mainVariation} />
          </td>
          {#each recommendations as recommendation}
            <td class="column oc-copy-100">
              <div class="attribute-header-placeholder"></div>
              <Rating variation={recommendation._embedded['o:variation']} />
            </td>
          {/each}
        </tr>
      </tbody>
    </table>
  </div>
{/if}

<style lang="scss">
  .reco_comparison__table__container {
    overflow-x: auto;
    padding: 24px 16px 12px 0;
  }

  .reco_comparison__table__header_title {
    padding-top: 4px;
    color: #000000;
  }

  .reco_comparison__table__header_data {
    padding: 12px 0;
  }

  tr > th:first-child,
  tr > td:first-child {
    position: sticky;
    left: 0;
    background: #ebf4ff;
    z-index: 1;
  }

  tbody tr > td {
    position: relative;
    padding-top: 12px;
    padding-bottom: 12px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-color: var(--oc-base-color-black-lighten-30);
      z-index: 0;
    }

    &:first-child::before {
      content: '';
      position: absolute;
      top: 0;
      left: 16px;
      right: 0;
      height: 1px;
      background-color: var(--oc-base-color-black-lighten-30);
      z-index: 0;
    }

    &:last-child::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 16px;
      height: 1px;
      background-color: var(--oc-base-color-black-lighten-30);
      z-index: 0;
    }
  }

  .column {
    padding-left: 16px;
    padding-right: 16px;
    vertical-align: top;
    max-width: 171px;
  }

  tr > th.column {
    padding-top: 10px;
  }

  ul > li {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .attribute-header {
    padding-bottom: 12px;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .attribute-header-placeholder {
    height: 28px;
  }

  .product-tag-placeholder {
    height: 20px;
  }

  .reco_comparison__table__adslink {
    color: black;
    text-decoration: none;
    overflow-y: auto;
  }
</style>
